import { render, staticRenderFns } from "./cookies-consent.vue?vue&type=template&id=b61ad944&scoped=true"
import script from "./cookies-consent.vue?vue&type=script&lang=js"
export * from "./cookies-consent.vue?vue&type=script&lang=js"
import style0 from "./cookies-consent.vue?vue&type=style&index=0&id=b61ad944&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61ad944",
  null
  
)

export default component.exports